// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"aO-z","carouselContainer":"bO-z"};